import { DEFAULT_THEME, themes } from './index'

export const mapTheme = (variables) => {
  return {
    '--color-primary':
      variables.primary.default || themes[DEFAULT_THEME].primary.default,
    '--color-primary-darker':
      variables?.primary?.darker ||
      variables?.primary?.default ||
      themes[DEFAULT_THEME].primary.darker,
    '--color-primary-lighter':
      variables?.primary?.lighter ||
      variables?.primary?.default ||
      themes[DEFAULT_THEME].primary.lighter,

    '--color-secondary':
      variables?.secondary?.default || themes[DEFAULT_THEME].secondary.default,
    '--color-secondary-darker':
      variables?.secondary?.darker ||
      variables?.secondary?.default ||
      themes[DEFAULT_THEME].secondary.darker,
    '--color-secondary-lighter':
      variables?.secondary?.lighter ||
      variables?.secondary?.default ||
      themes[DEFAULT_THEME].secondary.lighter,

    '--color-tertiary':
      variables?.tertiary?.default || themes[DEFAULT_THEME].tertiary.default,
    '--color-tertiary-darker':
      variables?.tertiary?.darker ||
      variables?.tertiary?.default ||
      themes[DEFAULT_THEME].tertiary.darker,
    '--color-tertiary-lighter':
      variables?.tertiary?.lighter ||
      variables?.tertiary?.default ||
      themes[DEFAULT_THEME].tertiary.lighter,

    '--color-positive':
      variables?.positive?.default || themes[DEFAULT_THEME].positive.default,
    '--color-positive-darker':
      variables?.positive?.darker ||
      variables?.positive?.default ||
      themes[DEFAULT_THEME].positive.darker,
    '--color-positive-lighter':
      variables?.positive?.lighter ||
      variables?.positive?.default ||
      themes[DEFAULT_THEME].positive.lighter,

    '--color-negative':
      variables?.negative?.default || themes[DEFAULT_THEME].negative.default,
    '--color-negative-darker':
      variables?.negative?.darker ||
      variables?.negative?.default ||
      themes[DEFAULT_THEME].negative.darker,
    '--color-negative-lighter':
      variables?.negative?.lighter ||
      variables?.negative?.default ||
      themes[DEFAULT_THEME].negative.lighter,

    '--color-grayscale':
      variables?.grayscale?.default || themes[DEFAULT_THEME].grayscale.default,
    '--color-grayscale-darker':
      variables?.grayscale?.darker ||
      variables?.grayscale?.default ||
      themes[DEFAULT_THEME].grayscale.darker,
    '--color-grayscale-lighter':
      variables?.grayscale?.lighter ||
      variables?.grayscale?.default ||
      themes[DEFAULT_THEME].grayscale.lighter,

    '--color-warning':
      variables?.warning?.default || themes[DEFAULT_THEME].warning.default,
    '--color-warning-darker':
      variables?.warning?.darker ||
      variables?.warning?.default ||
      themes[DEFAULT_THEME].warning.darker,
    '--color-warning-lighter':
      variables?.warning?.lighter ||
      variables?.warning?.default ||
      themes[DEFAULT_THEME].warning.lighter,
  }
}

export const applyTheme = (nameOrObject) => {
  let themeObject

  if (typeof nameOrObject === 'string') {
    themeObject = mapTheme(themes[nameOrObject])
  } else {
    themeObject = mapTheme(nameOrObject)
  }

  if (!themeObject) return

  const root = document.documentElement

  Object.keys(themeObject).forEach((property) => {
    if (property === 'name') {
      return
    }

    root.style.setProperty(property, themeObject[property])
  })
}

export const getTheme = (theme = DEFAULT_THEME) => {
  const themeObject = mapTheme(themes[theme])

  if (!themeObject) {
    return {}
  }

  return themeObject
}

export const getThemeAsString = (theme = DEFAULT_THEME) => {
  return Object.entries(getTheme(theme)).reduce((string, [key, val]) => {
    if (val !== '') {
      string = `${string} ${key}:${val};`
    }

    return string
  }, '')
}

export { extend } from './extend'
